import { injectMandatory } from "@/vf"
import type { InjectionKey } from "vue"

export const TaskViewMode = Symbol("TaskViewMode") as InjectionKey<"admin" | "customer">

export function useTaskViewMode() {
    return injectMandatory(TaskViewMode, "Missing mandatory injection: TaskViewMode")
}
